import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function SeeNOC({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  return (
    <FullBodyContentView
      title="Net Oil Total"
      fullCaption="NOC Oil Total @ Ref........................
      None...............................0.0f...............
      NOC Oil Total @ Ref........................
      None...............................0.0f...............
      NOC Oil Total @ Ref........................
      None...............................0.0f..............."
    />
  );
}

export default SeeNOC;
